<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <div class="resource-menu">
        <div :class="['resource-menu-item', kind == 1 ? 'active' : '']" @click="handleMenu(1)">
          视频资源
        </div>
        <div :class="['resource-menu-item', kind == 2 ? 'active' : '']" @click="handleMenu(2)">
          拓展阅读
        </div>
      </div>

      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form">
          <a-form-model-item prop="filename">
            <a-input v-model="form.filename" style="width: 200px" class="search-input" placeholder="请输入资源名称"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="course_id">
            <a-select v-model="form.course_id" placeholder="请选择课程" style="width: 200px" class="multiple-select" dropdownClassName="multipleDrop" @change="courseChange">
              <a-select-option value="">请选择课程</a-select-option>
              <a-select-option v-for="(item, index) in schoolTrainCourse" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="chapter_id">
            <a-select v-model="form.chapter_id" placeholder="请选择章节" style="width: 200px" class="chapter-select" dropdownClassName="chapterDrop">
              <a-select-option value="">{{form.course_id ? '请选择章节' : '请先选择课程'}}</a-select-option>
              <a-select-option v-for="(item, index) in schoolTrainChapter" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm">重置</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>

      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" rowKey="id" :bordered="false" size="small" :pagination="false">
          <template slot="filename" slot-scope="text">
            <div class="res-icon"></div>
            {{ text }}
          </template>
          <template slot="action" slot-scope="row, scope">
            <a-button type="link" @click="previewRes(scope)">预览</a-button>
            <a-button type="link" @click="downloadResource(scope, 1)">下载</a-button>
          </template>
        </a-table>

        <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
      </div>
    </div>

    <!-- 下载进度 -->
    <a-spin :tip="`下载中 ${downloadProgress}% ...`" :spinning="loading">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>

    <component :is="dialogConfig.name" :dialogConfig="dialogConfig"></component>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Bread from "../../../../components/school/Bread.vue";
import { downloadFile, downloadVideoFile, getDownloadUrl } from '../../../../assets/js/downloadUtils'; // 引入封装的方法
export default {
  components: {
    Bread,
    PreviewPdf: () => import('../../../../components/PreviewPdf'),
    PlayBox: () => import('../../../../components/PlayBox'),
  },
  data () {
    return {
      breadConfig: [{ name: "实践资源库" }, { name: "学习资源" }],
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        filename: "",
        course_id: "",
        chapter_id: "",
      },
      columns: [
        {
          title: "资源名称",
          dataIndex: "filename",
          scopedSlots: {
            customRender: "filename",
          },
        },
        {
          title: "类型",
          dataIndex: "format",
        },
        {
          title: "所属课程",
          dataIndex: "course_name",
        },
        {
          title: "所属章节",
          dataIndex: "chapter_name",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
        },
      ],
      kind: 1,
      dialogConfig: {
        type: "",
        name: "",
        fileId: "",
        path: "",
        title: "",
      },
      downloadProgress: 0,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      schoolTrainCourse: state => state.resourceLibrary.schoolTrainCourse, // 课程列表 
      schoolTrainChapter: state => state.resourceLibrary.schoolTrainChapter, // 课程章节
    }),
  },
  mounted () {
    this.getSchoolTrainCourse()
    this.getTableList();
  },
  methods: {
    ...mapActions(["getCourseResource", 'getSchoolTrainCourse', 'getSchoolTrainChapter',]),
    ...mapMutations(['setSchoolTrainChapter']),
    getTableList () {
      let params = {
        page: this.page,
        size: this.size,
        kind: this.kind,
        filename: this.form.filename,
        course_id: this.form.course_id,
        chapter_id: this.form.chapter_id,
      };
      this.getCourseResource(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
        }
      });
    },
    onSearch () {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange (val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    handleMenu (id) {
      this.kind = id;
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    resetForm () {
      this.$refs.ruleForm.resetFields();
      this.setSchoolTrainChapter({})
      this.onSearch()
    },
    // 课程筛选切换事件
    courseChange (val) {
      this.form.chapter_id = ''
      if (val) {
        this.getSchoolTrainChapter({ course_id: val })
      } else {
        this.setSchoolTrainChapter({})
      }
    },
    // 下载附件
    async downloadResource (row, downloadType) {
      try {
        this.loading = true;
        this.downloadProgress = 0;

        if (downloadType == 1) {
          // 课程资源下载
          if (row.type == 3) {
            // 视频文件下载
            await downloadVideoFile(row.url, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          } else {
            const downloadUrl = await getDownloadUrl("/api/school/train/course/resource/download", {
              id: row.id,
              course_id: row.course_id,
            }, (progress) => {
              this.downloadProgress = progress;
            });
            await downloadFile(downloadUrl, row.filename + (row.file_format ? '.' + row.file_format : ''), (progress) => {
              this.downloadProgress = progress;
            });
          }
        } 
      } catch (error) {
        console.error("下载失败", error);
        this.$message.error("下载失败");
      } finally {
        this.loading = false;
      }
    },
    // 文件流统一处理
    createUrlBlob (url, fileName) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', fileName);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    // 预览资源
    previewRes (item) {
      if (item.type != 1 && item.type != 2 && item.covert_status == 1) return this.$message.info("请等待转码完成后预览")
      if (item.type != 1 && item.type != 2 && item.covert_status == 3) return this.$message.info("转码失败")
      this.dialogConfig.title = item.filename + "." + item.file_format
      this.dialogConfig.type = item.type
      if (item.type == 1 || item.type == 2 || item.type == 4) {
        // 图片/音频/文档
        this.dialogConfig.path = item.view_url;
        this.dialogConfig.name = 'PreviewPdf';
      } else {
        // 视频
        this.dialogConfig.fileId = item.file_id
        this.dialogConfig.name = 'PlayBox';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.resource-menu {
    width: 100%;
    border-bottom: 1px solid #ececec;
    background: #fff url('../../../../assets/image/student/stepOne/bian.png')
        no-repeat;
    background-position: bottom right;
    background-size: 280px auto;
    margin-bottom: 15px;
    .resource-menu-item {
        display: inline-block;
        font-weight: bold;
        font-size: 14px;
        color: #545766;
        margin-right: 10px;
        width: 88px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        background: #f8f8f8;
        padding-bottom: 20px;
        position: relative;
        cursor: pointer;
        &.active {
            background: #b84b3c;
            color: #fff;
        }
    }
}
.res-icon {
    width: 13px;
    height: 13px;
    background: url('../../../../assets/image/school/common/res-icon.png')
        no-repeat center/cover;
    vertical-align: -1px;
    display: inline-block;
    margin-right: 6px;
}
</style>